import './historicoakland/style';
import FormStructure from './historicoakland/form_structure';

export default FormStructure;